// @ts-nocheck
import React from "react";
import styled from "styled-components";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Colors } from "../constants/colors";

export const ModalOverlay = styled.div<{ onClick?: () => void; children?: React.ReactNode }>(({ theme }) => ({
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: Colors.scrim,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    paddingLeft: theme.spacing.large,
    paddingRight: theme.spacing.large,
    maxWidth: "512px",
    margin: "0 auto",
}));

export const ModalContent = styled.div<{ children?: React.ReactNode }>(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.spacing.large,
    padding: theme.spacing.medium,
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "column",
}));

export const CloseButton = styled.button<{ onClick?: () => void; children?: React.ReactNode }>(({ theme }) => ({
    position: "absolute",
    top: theme.spacing.medium,
    right: theme.spacing.medium,
    background: "transparent",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const SuccessImage = styled(Image)(({ theme }) => ({
    width: 128,
    height: 104,
    objectFit: "contain",
    marginTop: `-${theme.spacing.medium}`,
    marginBottom: 18,
    alignSelf: "center",
}));

export const FailureImage = styled(Image)(({ theme }) => ({
    width: 128,
    height: 104,
    objectFit: "contain",
    marginTop: `-${theme.spacing.medium}`,
    alignSelf: "center",
}));

export const ModalTitle = styled(Text)(({ theme }) => ({
    textAlign: "center",
    marginBottom: theme.spacing.large,
    alignSelf: "center",
}));

export const ModalButton = styled(FullWidthButton)({
    width: "100%",
});
